<template>
  <base-container
    style="
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    "
    :isLoading="loading"
  >
    <el-form
      style="margin-top: 10px"
      label-position="right"
      label-width="80px"
      :model="formData"
      :rules="rules"
      size="mini"
      ref="ruleForm"
    >
      <el-form-item v-if="showWeek" label="排班星期" prop="weekNos">
        <el-checkbox-group v-model="formData.weekNos">
          <el-checkbox-button
            v-for="week in weeks"
            :key="week.weekNo"
            :label="week.weekNo"
          >
            {{ week.name }}
          </el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="排班时段">
        <el-time-select
          placeholder="起始时间"
          v-model="formData.startTime"
          :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '24:00',
          }"
        >
        </el-time-select>
        <span class="margin-h10">-</span>
        <el-time-select
          placeholder="结束时间"
          v-model="formData.endTime"
          :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '24:00',
            minTime: formData.startTime,
          }"
        >
        </el-time-select>
      </el-form-item>
      <el-form-item label="分时间隔" prop="duration">
        <el-radio-group
          :disabled="!formData.startTime || !formData.endTime"
          v-model="formData.duration"
        >
          <el-radio-button :label="0">不分时</el-radio-button>
          <el-radio-button :label="30">30分钟</el-radio-button>
          <el-radio-button :label="60">60分钟</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <artisan-group style="flex: 1; overflow-y: auto" title="时段号源">
      <div
        class="padding-h7"
        style="border-left: 5px solid #f56c6c; background-color: #f5f7f9"
      >
        <el-row
          class="padding-v5"
          type="flex"
          justify="space-between"
          align="middle"
        >
          <el-col :span="8">时段-批量设置</el-col>
          <el-col :span="8">
            时段号源:
            <el-input-number
              style="width: auto"
              :min="0"
              size="mini"
              :controls="false"
              v-model="numCount"
              @blur="popChange('numCount')"
              @keyup.enter.native="popChange('numCount')"
            ></el-input-number>
          </el-col>
          <el-col :span="8">
            预留号源:
            <el-input-number
              style="width: auto"
              :min="0"
              size="mini"
              :controls="false"
              v-model="saveCount"
              @blur="popChange('saveCount')"
              @keyup.enter.native="popChange('saveCount')"
            ></el-input-number>
          </el-col>
        </el-row>
        <el-row class="padding-v5" type="flex" align="middle">
          <el-col :span="8">
            签到时间:
            <el-time-select
              size="mini"
              style="width: 100px"
              placeholder="起始时间"
              v-model="signStart"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00',
              }"
              @change="popChange('signStart')"
            >
            </el-time-select>
            <span class="margin-h10">-</span>
            <el-time-select
              style="width: 100px"
              size="mini"
              placeholder="结束时间"
              v-model="signEnd"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00',
                minTime: signStart,
              }"
              @change="popChange('signEnd')"
            >
            </el-time-select>
          </el-col>
          <el-col :span="8">
            授权渠道:
            <el-select
              size="mini"
              collapse-tags
              multiple
              v-model="appIds"
              @change="popChange('appIds')"
            >
              <el-option
                :label="app.label"
                v-for="app in appList"
                :key="app.value"
                :value="app.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            就诊类型:
            <el-radio-group
              size="mini"
              v-model="clinicType"
              @change="popChange('clinicType')"
            >
              <el-radio-button label="">不限</el-radio-button>
              <el-radio-button label="outpatient">门诊</el-radio-button>
              <el-radio-button label="inpatient">住院</el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>
        <div
          v-show="numCount < saveCount"
          class="align-center color-danger padding-v3"
        >
          预留号源数必须小于时段号源数
        </div>
      </div>
      <div
        class="margin-v12 padding-h7"
        style="border-left: 5px solid #1989fa; background-color: #f5f7f9"
        v-for="(period, i) in formData.periods"
        :key="i"
      >
        <el-row class="padding-v5" type="flex" align="middle">
          <el-col :span="8">
            <b class="color-primary"
              >{{ i + 1 }}. {{ period.startPoint }}-{{ period.endPoint }}</b
            >
          </el-col>
          <el-col :span="8">
            时段号源:
            <el-input-number
              style="width: auto"
              :min="0"
              size="mini"
              :controls="false"
              v-model="period.numCount"
            ></el-input-number>
          </el-col>
          <el-col :span="8">
            预留号源:
            <el-input-number
              style="width: auto"
              :min="0"
              size="mini"
              :controls="false"
              v-model="period.saveCount"
            ></el-input-number>
          </el-col>
        </el-row>
        <el-row class="padding-v5" type="flex" align="middle">
          <el-col :span="8">
            签到时间:
            <el-time-select
              style="width: 100px"
              size="mini"
              placeholder="起始时间"
              v-model="period.signStart"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00',
              }"
            >
            </el-time-select>
            <span class="margin-h10">-</span>
            <el-time-select
              style="width: 100px"
              size="mini"
              placeholder="结束时间"
              v-model="period.signEnd"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00',
                minTime: period.signStart,
              }"
            >
            </el-time-select>
          </el-col>
          <el-col :span="8">
            授权渠道:
            <el-select
              multiple
              collapse-tags
              size="mini"
              v-model="period.appIds"
            >
              <el-option
                :label="app.label"
                v-for="app in appList"
                :key="app.value"
                :value="app.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            就诊类型:
            <el-radio-group size="mini" v-model="period.clinicType">
              <el-radio-button label="">不限</el-radio-button>
              <el-radio-button label="outpatient">门诊</el-radio-button>
              <el-radio-button label="inpatient">住院</el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>
        <div
          v-show="period.numCount < period.saveCount"
          class="align-center color-danger padding-v3"
        >
          预留号源数必须小于时段号源数
        </div>
      </div>
    </artisan-group>
  </base-container>
</template>

<script>
import Config from "@/config/constant";
import { loadEnum } from "@/api/sys/dicType";
export default {
  props: {
    showWeek: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      weeks: Config.weeks,
      formData: {
        startTime: "",
        endTime: "",
        weekNos: ["1", "2", "3", "4", "5", "8"],
        duration: "0",
        periods: [],
      },
      numCount: 0,
      signStart: "00:00",
      signEnd: "24:00",
      clinicType: "",
      saveCount: 0,
      ruleIds: [],
      appIds: [],
      appList: [],
      rules: {
        weekNos: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个",
            trigger: "change",
          },
        ],
        startTime: [
          {
            type: "string",
            required: true,
            message: "开始时间必填",
            trigger: "change",
          },
        ],
        endTime: [
          {
            type: "string",
            required: true,
            message: "结束时间必填",
            trigger: "change",
          },
        ],
        duration: [
          { required: true, message: "请选择分时", trigger: "change" },
        ],
      },
    };
  },
  watch: {
    "formData.duration": function () {
      this.calcPeriods();
    },
    "formData.startTime": function () {
      this.calcPeriods();
    },
    "formData.endTime": function () {
      this.calcPeriods();
    },
  },
  created() {
    loadEnum("SysAppInfo").then((res) => {
      this.appList = res.data.data;
    });
  },
  methods: {
    calcPeriods() {
      if (this.formData.startTime && this.formData.endTime) {
        let periods = [];
        if (this.formData.duration == "30") {
          periods = this.buildPeriods(true);
        } else if (this.formData.duration == "60") {
          periods = this.buildPeriods(false);
        } else {
          periods.push({
            startPoint: this.formData.startTime,
            endPoint: this.formData.endTime,
            signStart: "00:00",
            signEnd: "24:00",
            clinicType: "",
            numCount: 0,
            saveCount: 0,
            ruleIds: [],
            appIds: [],
          });
        }
        this.formData.periods = periods;
      } else {
        this.formData.duration = "0";
        this.formData.periods = [];
      }
    },
    buildPeriods(isHalf) {
      let periods = [];
      let startPoint = this.formData.startTime;
      while (this.compareTime(startPoint, this.formData.endTime)) {
        let endPoint = this.addMinute(startPoint, isHalf);
        if (!this.compareTime(endPoint, this.formData.endTime)) {
          endPoint = this.formData.endTime;
        }
        periods.push({
          startPoint,
          endPoint,
          signStart: "00:00",
          signEnd: "24:00",
          clinicType: "",
          numCount: 0,
          saveCount: 0,
          ruleIds: [],
          appIds: [],
        });
        startPoint = endPoint;
      }
      return periods;
    },
    compareTime(t1, t2) {
      let val1 = parseFloat(t1.replace(":", "."));
      let val2 = parseFloat(t2.replace(":", "."));
      return val1 < val2;
    },
    addMinute(period, isHalf) {
      let arr = period.split(":");
      if (parseInt(arr[1]) > 0) {
        if (isHalf) {
          arr[0] = (parseInt(arr[0]) + 1).toString();
          arr[1] = "00";
        } else {
          arr[0] = (parseInt(arr[0]) + 1).toString();
        }
      } else {
        if (isHalf) {
          arr[1] = "30";
        } else {
          arr[0] = (parseInt(arr[0]) + 1).toString();
        }
      }
      if (arr[0].length == 1) {
        arr[0] = "0" + arr[0];
      }
      return arr.join(":");
    },
    popChange(code) {
      this.formData.periods.forEach((c) => {
        c[code] = this[code];
      });
    },
    summaryChange(isSave) {
      if (isSave) {
        if (this.formData.periods.length) {
          const remainder = this.saveCount % this.formData.periods.length;
          const count = parseInt(this.saveCount / this.formData.periods.length);
          this.formData.periods.forEach((c) => {
            c.saveCount = count;
          });
          this.formData.periods[this.formData.periods.length - 1].saveCount +=
            remainder;
        }
      } else {
        if (this.formData.periods.length) {
          const remainder = this.numCount % this.formData.periods.length;
          const count = parseInt(this.numCount / this.formData.periods.length);
          this.formData.periods.forEach((c) => {
            c.numCount = count;
          });
          this.formData.periods[this.formData.periods.length - 1].numCount +=
            remainder;
        }
      }
    },
    getRules() {
      return this.formData;
    },
  },
};
</script>

<style></style>
